// getDiscounts.js

async function fetchDiscounts() {
    const apiUrl = '/admin/api/2023-10/price_rules.json';
    const token = "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"; // Ersetze durch dein tatsächliches Token

    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Access-Token': token
            }
        });

        if (!response.ok) {
            throw new Error(`Fehler: ${response.status}`);
        }

        const data = await response.json();
        displayDiscounts(data.price_rules);
    } catch (error) {
        console.error('Error fetching discount data:', error);
    }
}

// Funktion zur Ausgabe der Rabattdaten im HTML
function displayDiscounts(discounts) {
    const discountContainer = document.getElementById('discounts-container');

    const selectedDiscountTitle = discountContainer.getAttribute('data-selected-discount');
    const selectedDiscountDescription = discountContainer.getAttribute('data-discount-description');


    if (!discountContainer) return;

    discounts.forEach((discount) => {
        const discountDiv = document.createElement('div');
        discountDiv.classList.add('discount-item');

        const endDate = new Date(discount.ends_at);
        const now = new Date();

        var seconds = Math.floor((endDate - (now)) / 1000);
        var minutes = Math.floor(seconds / 60);
        var hours = Math.floor(minutes / 60);
        var days = Math.floor(hours / 24);

        hours = hours - (days * 24);
        minutes = minutes - (days * 24 * 60) - (hours * 60);
        seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
        discountValue = discount.value * -1;
        if (discount.value_type == "percentage" || discount.value_type == "prozent") {
            var type = "%";
        } else if (discount.value_type == "fixed amount") {
            var type = "€";
        };

        if (discount.title == selectedDiscountTitle) {

            const bannerHeadline = document.createElement('div');
            bannerHeadline.classList.add('banner-headline');

            const descriptionSpan = document.createElement('span');
            descriptionSpan.textContent = selectedDiscountDescription;
            descriptionSpan.innerHTML = selectedDiscountDescription.replace(/^<p>|<\/p>$/g, '');
            bannerHeadline.appendChild(descriptionSpan);

            // Banner Inner Grid
            const bannerInnerGrid = document.createElement('div');
            bannerInnerGrid.classList.add('grid', 'banner-inner-grid');


            const buttonDiv = document.createElement('div');
            const aDiv1 = document.createElement('div');
            const aDiv2 = document.createElement('div');
            buttonDiv.id = "button_div";
            aDiv2.classList.add('banner-inner-grid-last-child');
            const buttonAnchor = document.createElement('button');
            buttonDiv.classList.add('copy_button');
            buttonAnchor.id = "copy_button";

            const codeAnchor = document.createElement('a');
            codeAnchor.classList.add('banner_a_tag');
            codeAnchor.textContent = `Code: ${discount.title}`;

            const countdownAnchor = document.createElement('a');
            countdownAnchor.classList.add('banner_a_tag');
            if (endDate > now) {
                countdownAnchor.textContent = `Noch ${days} Tage ${hours} Std ${minutes} Min`;
            } else if (discount.ends_at == null) {
                countdownAnchor.textContent = "";
            }
            else {
                countdownAnchor.textContent = `Abgelaufen`;
            }
            aDiv1.appendChild(codeAnchor);
            buttonDiv.appendChild(buttonAnchor);
            aDiv2.appendChild(countdownAnchor);

            bannerInnerGrid.appendChild(aDiv1);
            bannerInnerGrid.appendChild(buttonDiv);
            bannerInnerGrid.appendChild(aDiv2);


            // Append everything to discountDiv
            discountDiv.appendChild(bannerHeadline);
            discountDiv.appendChild(bannerInnerGrid);

            discountContainer.appendChild(discountDiv);
            displayCopyButton(discount.title, 'copy_button');
        }
    });
}

function displayCopyButton(textToCopy, copyButton) {
    const button_div = document.getElementById('button_div');
    document.getElementById(copyButton).addEventListener('click', function () {        
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                button_div.classList.add("active");  // Popover anzeigen
                setTimeout(() => {
                  button_div.classList.remove("active");  // Nach 2 Sekunden ausblenden
                }, 1500);
            })
            .catch(err => {
                console.error('Fehler beim Kopieren: ', err);
            });
    });
}

// Automatisch die Funktion ausführen, wenn das Skript geladen wird
fetchDiscounts();
